import { Component, OnInit, DoCheck, OnDestroy,
  ViewChild, ElementRef, ViewChildren, HostListener, NgZone
} from '@angular/core';
import { Config } from '../../config/config';
import * as $ from 'jquery';
import { Location } from '@angular/common';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Unlisten } from '../../keyboard-shortcuts/keyboard-shortcuts';
import { Subscription } from 'rxjs';
import { SharedDataService } from '../../service/shared-data.service';
import { SnotifyService } from 'ng-snotify';
import { DragulaService } from 'ng2-dragula';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PageListingComponent } from '../page-listing/page-listing.component';
import { flatMap } from 'rxjs/operators';
import { Chart } from 'chart.js';
import {parse, stringify} from 'flatted';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from '../../service/localstorage.service';
import Editor from "../../../assets/js/ckeditor";
import { CKEditorComponent, ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import * as moment from 'moment';

@Component({
  selector: 'collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit, OnDestroy, DoCheck {
  cardId = this.route.snapshot.paramMap.get('id');
  page_id = StaticDataService.element_page_id;
  save_api = StaticDataService.element_save_api;
  get_api = StaticDataService.element_get_api;
  lockAcquire_api = StaticDataService.story_lockAcquire_api;
  lockRelease_api = StaticDataService.story_lockRelease_api;
  unlock_element = StaticDataService.element_unlock_api;
  all_element_api = StaticDataService.element_byids_api;
  subscription: Subscription[] = [];
  cardData: any;
  subtypeQuery = '';
  tagtypeQuery = '';
  errorShow = false;
  popupTitle: string;
  isCursorHovering = false;
  namePresent = false;
  autosave: any;
  publishFlag = false;
  getnewData = false;
  firstLoadCheck = 0;
  labelText: string;
  storyType: string;
  allSubSections = [];
  private unlisten: Unlisten;
  cardTitle: string;
  insideSection = false;
  sectionSuggestion = [];
  collectionTypeSuggestion = [];
  subSectionSuggestion = [];
  sectionInputSuggestion = [];
  filteredDesignSuggestion = [];
  filteredBannerDesignSuggestion = [];
  filteredCollectionTypeSuggestion = [];
  filteredSectionSuggestion = [];
  filteredSubSectionSuggestion = [];
  filteredPositionTypeSuggestion = [];
  positionTypeSuggestion = [];
  lastCardData = null;
  editCardFlag = false;
  editCardId: string;
  embedPopup = true;
  subTypeSuggestion = [];
  tagTypeSuggestion = [];
  isLocked = false;
  embedCode = '';
  embedCode2 = '';
  backColor: string;
  insideSubSection = false;
  color = 'Black';
  colorValue = '#000000';
  pageName: string;
  externalUrl = null;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('collectionTypeInput') collectionTypeField;
  @ViewChildren('positionTypeInput') positionTypeField;
  @ViewChildren('brunchInput') brunchField;
  @ViewChildren('subSectionInput') subSectionField;
  @ViewChild('sectionList',{static: false}) sectionList;
  @ViewChild('subSectionList', {static: false}) subSectionList;
  @ViewChildren('section') section;
  @ViewChild('storyCollection', {static: false}) storyCollection : PageListingComponent;
  @ViewChildren('seriesPageInput') seriesPageField;
  mergeData: string;
  sectionQuery = 'Design 1';
  bannerDesignQuery = 'Design 2';
  collectionTypeQuery = '';
  positionTypeQuery = '';
  sectionInputQuery = '';
  subSectionQuery = '';
  currentSelection = 0;
  cardLoaded = false;
  defaultcardData = null;
  changeFlag = false;
  pageTitle: string;
  collectionStories = [];
  collectionPages =[];
  form: FormGroup;
  showLabel: Boolean;
  Category = 'story';
  subscriptions: Subscription[] = [];
  subType = '';
  filteredsubTypeSuggestion = [];
  filteredtagTypeSuggestion = [];
  insideSubType = false;
  insideTagType = false;
  insideDesign = false;
  insideCollectionType = false;
  insidePositionType:boolean = false;
  subTypes = [];
  isSection = false;
  isSubSection = false;
  errorModalOnPublish = false;
  validationFlag = false;
  errorDisplayArray = [];
  @ViewChild('secondaryCTAs', {static: false}) secondaryCTA: ElementRef;
  revertListFlag = false;
  @ViewChildren('subTypeInput') subTypeField;
  @ViewChildren('tagTypeInput') tagTypeField;
  requestInQueue = false;
  domainConfig: any;
  elementsDisabled = [];
  multiplePageListingFlag = false;
  showAmazonMeta: boolean;
  newAdName: string;
  newAdEmbed: string;
  amazonNewAd: boolean;
  amazonAds= [];
  pushPinnedArticles = [];
  trustedHTML = null;
  trustedHTML2 = null;
  count: string;
  saveRequestSent: boolean = false;
  countChange: boolean = false;
  tablePopup = false;
  tableHTML = '';
  public Editor = Editor;
  table=null;
  pickStoryImageLoad:boolean= false;

  tableConfig = {
    toolbar: ['bold', 'italic', 'underline', 'numberedList', 'bulletedList', 'link', '|', 'insertTable'],
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    disableTwoWayDataBinding: false
  };
  designPopup = false;
  designImage: string;
  chartConfig = null;
  tableEditor = null;
  chart = null;
  chartType = 'line';
  chartTypes = ['line', 'bar', 'pie', 'doughnut'];
  chartLabels = {
    chartlabel: '',
    xlabel: '',
    ylabel: ''
  };
  newMetas = [];
  SingleselectedFile: File;
  imageUploadInProgress: boolean;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  showCropper: boolean;
  croppingInProgress: boolean;
  isPhotopopup: boolean;
  isLightbox: boolean;
  bannerName: string;
  bannerUrl: string;
  tempBannerImgUrl: any;
  enableAmpWebAppFlag:boolean;
  enableTagTypeApp:boolean;
  ampWebAppTypeElements=[];
  typeCollectionFlags=[];
  accessType = "";
  user :any;
  @ViewChild('editorTable',{static:false})
  editorTable: CKEditorComponent;
  insideBrunch: boolean;
  selectedBrunchEdition: string = '';
  brunchEditionFilter: any = [];
  brunchEditionData: any = [];
  brunchMap:Map<String,any> = new Map<String,any>();
  insideSeriesPage: boolean;
  selectedSeriesPage: string = '';
  seriesPageFilter: any = [];
  seriesPageData: any = [];
  seriesPageMap:Map<String,any> = new Map<String,any>();
  burnchAllData: any;
  disabledCropper: boolean;
  tenantWiseCropper: boolean;
  matchPopupMeta:boolean = false;
  editMatchPopupMeta:boolean = false;
  constructor(
    private route: ActivatedRoute,
    private sharedService: SharedDataService,
    public config: Config,
    private router: Router,
    private location: Location,
    public restService: RestDataService,
    private snotify: SnotifyService,
    private fb: FormBuilder,
    private ngZone: NgZone,
    private http: HttpClient,
    private dragulaService: DragulaService,
    private localstorageService:LocalstorageService,
    private gaService:GoogleAnalyticsService
  ) {
    this.snotify.clear();
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.createForm();
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.user = this.restService.userDetail;
    if(this.user.domainPermissions[currentDomain].elementPermissions)
    {
      this.accessType = this.user.domainPermissions[currentDomain].elementPermissions.accessType;
    }
    this.elementsDisabled = this.domainConfig['elementsDisabled'];
    if (dragulaService.find('new-bag') == undefined) {
      dragulaService.setOptions('new-bag', {
        moves: function (el, container, handle) {
          return (handle.className === 'handle sortpara' || handle.className === 'icon-move newbag');
        }
      });
    }

    if (dragulaService.find('second-bag-new') == undefined) {
      dragulaService.setOptions('second-bag-new', {
        moves: function (el, container, handle) {
          return (handle.className === 'handle sortpara' || handle.className === 'icon-move secondbag');
        }
      });
    }
  }
  sectionName: string;
  objTrendingTopics = {};
  objKeys = [];
  trending: string;
  trendingUrl: string;

  ngOnInit() {
    if (this.cardId && this.cardId.indexOf('?domain') > -1) {
      this.cardId = this.cardId.substring(0, this.cardId.indexOf('?domain'));
    }
    this.getDesignList();
    this.getCollectionTypeList();
    this.getStoryMetaList();
    this.getElementMeta();
    this.fetchBrunchEdition();
    this.getPositionTypeList();
    this.fetchSeriesPage();
   // this.sharedService.setTitle('elements');
   const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
   const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
   if (conf && domain) {
     this.domainConfig = JSON.parse(conf)[domain];
     this.enableAmpWebAppFlag=this.sharedService.isdomainConfig('collection','enableAmpWebAppFlag')
     this.ampWebAppTypeElements = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['collection']
      && this.domainConfig['config']['collection']['ampWebAppTypeElements']) ? this.domainConfig['config']['collection']['ampWebAppTypeElements'].split(',') : [];
      this.enableTagTypeApp=this.sharedService.isdomainConfig('collection','enableTagTypeApp')
    this.typeCollectionFlags = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['collection']
      && this.domainConfig['config']['collection']['typeCollectionFlags']) ? this.domainConfig['config']['collection']['typeCollectionFlags'].split(',') : [];
    this.disabledCropper = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['collection']
    && this.domainConfig['config']['collection']['disabledCropper']
   } else {
     this.domainConfig = StaticDataService.defaultConfig;
   }
    this.subscriptions.push(
      this.sharedService.getData().subscribe(x => {
        if (x === 'elementPublish') {
          this.cardPush(true);
        }
      })
    );

    if (this.cardId !== null) {
      this.lockAcquire(this.cardId, flag => {
        if (flag && !(this.accessType=='View')) {
          this.loadView(this.cardId, false);
          this.editCardFlag = true;

        } else {
          this.loadView(this.cardId, true);
          this.cardLoaded = false;
          this.changeFlag = false;
          this.editCardFlag = false;
        }
        this.embedPopup = false;
      });
    } else {
      this.route.queryParams.subscribe(params => {
        this.editCardFlag = true;
        this.cardLoaded = true;
        this.isLocked = true;
        if (
            params['type'] &&
            (this.elementsDisabled.indexOf(params['type']) === -1) &&
            (params['type'] === 'collection'
            || params['type'] === 'embed'
            || params['type'] === 'jsonfeed'
            || params['type'] === 'toptrends'
            || params['type'] === 'banner'
            || params['type'] === 'communities'
            || params['type'] === 'chart'
            || params['type'] === 'table'
            || params['type'] === 'placeholder'
            )
          ) {
          this.storyType = params['type'];
          if (params['type'] === 'embed') {
            this.embedPopup = true;
            this.storyType = 'embed';
            this.popupTitle = 'Add Embed';
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.sharedService.setTitle('New embed element');
          } else if (params['type'] === 'jsonfeed') {
            this.embedPopup = true;
            this.storyType = 'jsonfeed';
            this.popupTitle = 'Add JSON';
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultjsonfeedCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.sharedService.setTitle('New JSON embed element');
          } else if (params['type'] === 'placeholder') {
            this.embedPopup = false;
            this.storyType = 'placeholder';
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultPlaceholderCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.sharedService.setTitle('New JSON embed element');
            this.snotify.info('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
          } else if (params['type'] === 'collection') {
            this.sharedService.setTitle('New Collection');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultCollectoionCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.storyType = 'collection';
          } else if (params['type'] === 'toptrends') {
            this.sharedService.setTitle('Add Top Trends & Trending Topics');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultTopTrendsCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.storyType = 'toptrends';
          } else if (params['type'] === 'banner') {
            this.sharedService.setTitle('Add Banner');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultBannerCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.storyType = 'banner';
          } else if (params['type'] === 'communities') {
            this.sharedService.setTitle('New Communities');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultCommunitiesCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.storyType = 'collection';
            this.multiplePageListingFlag = true;
            this.Category = 'page';
          } else if (params['type'] === 'chart') {
            this.sharedService.setTitle('New Chart');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultTableCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.defaultcardData.type = 'chart';
            this.defaultcardData.reusable = true;
            // this.defaultcardData.embed.body = true;
            this.defaultcardData.chart = {
              chartBody: '',
              configString: JSON.stringify(StaticDataService.chartConfig),
              images: {}
            };
            this.storyType = 'chart';
            this.chartType = 'line';
            this.tableHTML = '';
            this.chartConfig = JSON.parse(JSON.stringify(StaticDataService.chartConfig));
            this.tablePopup = true;
          }
          else if (params['type'] === 'table') {
            this.sharedService.setTitle('New Table');
            this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultTableCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.defaultcardData.type = 'table';
            this.defaultcardData.reusable = true;
            // this.defaultcardData.embed.body = true;
            this.defaultcardData.paragraph = {
              body: '',

            };
            this.storyType = 'table';
            this.tableHTML = '';
            this.tablePopup = true;
          }

        } else {
          this.storyType = 'collection';
          this.sharedService.setTitle('New collection');
          this.defaultcardData = JSON.parse(JSON.stringify(StaticDataService.defaultCollectoionCardData));
            this.defaultcardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        }

      });
      setTimeout(e => {
        this.cardData = Object.assign({}, this.defaultcardData);
        this.loadJqueryViewMethods();
        this.editCardFlag = true;
        this.cardLoaded = true;
      }, 250);
    }
    this.newMetas = this.domainConfig['collectionDynamicMeta'];
  }
  createForm() {
  const reg = '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.[^ ]*)?$';
    if (this.sharedService.isdomainConfig('collection','noExternalUrlValidation')) {
      this.form = this.fb.group({
        s_url: [],
      });
    } else {
      this.form = this.fb.group({
        s_url: ['', [Validators.pattern(reg)]],
      });
    }
  }

  // Getter for easy access
  get s_url() {
    return this.form.get('s_url');
  }

  getElementMeta() {
   //collection specific /cms-backend-service-mt/api/cms/element/meta
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'element_meta')
    ).subscribe(data => {
      console.log('data',data)
      this.subTypes = data['elementSubTypes'];
      this.subTypeSuggestion = data['elementSubTypes'];
      this.tagTypeSuggestion = data['elementTagTypes'];
    });
    // let metaData=this.localstorageService.getMetaData();
    // console.log('collection component metadata',metaData);
    // this.subTypes = metaData['elementSubTypes'];
    //this.subTypeSuggestion = metaData['elementSubTypes'];
    //  this.facets=metaData;
  }

  selectSubType(value) {
    this.cardData.subType = value;
    this.subType = value;
  }

  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    this.loadJqueryViewMethods();
  }

  loadJqueryViewMethods() {
    if (this.cardData && this.cardData.title) {
      this.namePresent = true;
    }
    if (this.cardLoaded) {
      this.generateCardAutoSaveInterval();
      this.sharedService.overflowauto();
    }
  }

  hoverEnter() {
    this.isCursorHovering = true;
  }
  hoverLeave() {
    this.isCursorHovering = false;
  }
  disableElement(): boolean {
    return (this.editCardFlag && (this.isCursorHovering));
  }
  onelementFocus() {
    this.embedCode = this.cardData.embed.body;
    this.embedCode2 = this.cardData.embed.body2;
    this.embedPopup = true;
  }
  closeEmbedPopup() {
    this.embedPopup = false;
    this.embedCode = '';
    this.embedCode2 = '';
    if (this.cardId == null && this.cardData.id == null) {
      this.router.navigate(['/dash/elements']);
    }
  }

  openEmbedPopup() {
    this.embedPopup = true;
    this.embedCode = '';
    this.embedCode2 = '';
  }
  changeEmbed() {
    if (this.storyType === 'jsonfeed') {
      if (this.testJSON(String(this.embedCode))) {
        if (this.embedCode.trim() === '{}') {
           this.embedCode = '';
        }
        this.cardData.embed.body = this.embedCode;
        this.embedPopup = false;
        this.changeFlag = true;
        this.cardPush(false);
        this.embedCode = '';
      } else {
        this.snotify.error('Please enter a valid JSON', '', this.sharedService.getConfig(false));
      }
    } else if (this.storyType === 'embed') {
      if (((this.embedCode === null) || (this.embedCode === '')) && (this.amazonAds && this.amazonAds.length > 0)) {
       setTimeout(e => {
              this.saveEmbed();
            }, 20);

      } else if (this.embedCode && this.embedCode !== null && this.embedCode.trim() !== '') {
        if (this.sharedService.isdomainConfig('story','autoEmbed')) {
          this.sharedService.checkAndGetEmbed(this.embedCode, (embed) => {
            this.sharedService.checkAndGetEmbed(this.embedCode2, (embed2) => {
            if (embed !== null) {
              this.embedCode = embed;
            }
            if (embed2 !== null) {
              this.embedCode2 = embed2;
            }
            setTimeout(e => {
              this.saveEmbed();
            }, 20);
          });
          });
        } else {
          this.saveEmbed();
        }

      } else {
        this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
      }
    }
  }
  onFileChange(event,tenantWiseCropper?) {
    this.tenantWiseCropper = tenantWiseCropper
    const reader: FileReader = new FileReader();
    this.SingleselectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((typeof event.target.files[0]) === 'object') {
        if ((this.SingleselectedFile.size / 1000000) <= 11) {
          const a = reader.readAsDataURL(event.target.files[0]);
          reader.onload = (e: any) => {
            this.openCropper(e.target.result);
          };
        } else {
          this.SingleselectedFile = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    }
    this.sharedService.overflowhidden();
    event.target.value = '';
  }
  finishCropping(event) {
    const requests = event.cropRequests;
    this.cancelCropping();
    this.croppingInProgress = true;
    this.sharedService.croppingSequence(requests, false, data => {
      this.croppingInProgress = false;
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        console.log(data)
        this.tempBannerImgUrl = data['imagemap']['360x181'];
      } else {
        console.log(data);
      }
    });

  }
  deleteTempBanner() {
    this.tempBannerImgUrl = '';
  }

  openCropper(data) {
    // this.pickStoryImageLoad = true;
    const fd = new FormData();
    fd.set('file', this.SingleselectedFile, this.SingleselectedFile.name);
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
      subscribe(res => {
        this.cropperImageUrl.url = res['images']['original'];
        this.cropperImageUrl.data = data;
        if(this.tenantWiseCropper){
          if(this.disabledCropper) {
            this.tempBannerImgUrl = res['images']['original'];
          } else {
            this.showCropper = true;
          }
          this.tenantWiseCropper = false
        }
         else {
             this.showCropper = true;
        }
      },
        err => {
          this.snotify.clear();
          this.snotify.info('Cropping Failed', '', this.sharedService.getConfig(false));
        });
  }

  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      blobData: null,
      data: null
    };
    this.SingleselectedFile = null;
    // this.pickStoryImageLoad = false;
  }


  showGallery() {
    this.isPhotopopup = true;
    this.isLightbox = true;
    this.sharedService.overflowhidden();
  }
  disableshowGallery() {
    this.isLightbox = false;
    this.isPhotopopup = false;
    this.sharedService.overflowauto();
  }

  getImageId(ev, temp = false,tenantWiseCropper?) {
    if(ev.type === 'image') {
      this.tenantWiseCropper = tenantWiseCropper;
      this.createDuplicateImageChild(ev.id, fn => {
        if (fn !== false) {
          this.cropperImageUrl.url = this.config.get('product').baseUrl + StaticDataService.proxyImage + fn['image']['images']['original'];
          this.sharedService.createObjectFromImageUrl( this.config.get('product').baseUrl + StaticDataService.proxyImage + fn['image']['images']['original'], (data, reader) => {
            this.cropperImageUrl.data = data.data;
          });
          if(tenantWiseCropper){
            if(this.disabledCropper) {
              this.tempBannerImgUrl = fn['image']['images']['original'];
            } else {
              this.showCropper = true;
            }
            this.tenantWiseCropper = false;
          } else {
            this.showCropper = true;
          }
        } else {
          // console.log('couldn\'nt create duplicate child');
        }
      });
    } if(ev.type === 'wire') {
      console.log(ev)
      this.saveCardNewImage(ev, fn => {
        console.log(fn)
        if (fn !== false) {
          this.cropperImageUrl.url = fn['image']['images']['original'];
          this.sharedService.createObjectFromImageUrl(fn['image']['images']['original'], (data, reader) => {
            // console.log(data);
            this.cropperImageUrl.data = data.data;
          });
          // console.log(this.cropperImageUrl)
          this.showCropper = true;
        } else {
          // console.log('couldn\'nt create duplicate child');
        }
      });
    }
    this.disableshowGallery();
  }

  createDuplicateImageChild(id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/' + id
    )
      .subscribe(result => {
        // let defaultImagecardData = $.extend(true, {}, result);
        const defaultImagecardData = Object.assign({}, result);
        defaultImagecardData['id'] = null;
        defaultImagecardData['parentElementId'] = id;
        if(this.disabledCropper && this.tenantWiseCropper) {
          defaultImagecardData.image.images ={'original' :result.image.images['original']};
        }
        // this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          defaultImagecardData, result2 => {
            // this.decreasePendingCount();
            if (!result2.hasOwnProperty('error')) {
              callback(result2);
            } else {
              callback(false);
            }
          });
      },
        err => {
          // console.log(err);
          callback(false);
        });
  }

  saveCardNewImage(imagePath, callback) {
    // console.log(imagePath);
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd2 = new FormData();
    fd2.set('file', imagePath.id);
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd2).
      subscribe(res => {
        if (defaultImagecardData) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';
          // defaultImagecardData.image.images['960x540'] = imagePath.replace(/"/gi, '');
          // defaultImagecardData.image.images['250x250'] = imagePath.replace(/"/gi, '');
          // defaultImagecardData.image.images['90x60'] = imagePath.replace(/"/gi, '');
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              if (!result.hasOwnProperty('error')) {
                callback(result);
              } else {
                callback(false);
              }
            });
        }
      });
  }

  saveEmbed() {
    // if(this.validateEmbedJSON(this.embedCode) && this.validateEmbedJSON(this.embedCode2)){

      if(this.showAmazonMeta) {
        this.cardData.amazonAds = this.amazonAds;
        this.cardData.amazonMeta = true;
        this.cardData.embed.body = '';
        this.cardData.embed.body2 = '';
        this.newAdName = '';
        this.newAdEmbed = '';
        this.embedPopup = false;
        this.changeFlag = true;
        this.publishFlag = false;
        this.showAmazonMeta = true;
        this.cardPush(false);
      } else {
        this.cardData.amazonAds = [];
        this.amazonAds = [];
        this.showAmazonMeta = false;
        this.cardData.amazonMeta = false;
        this.cardData.embed.body = this.sharedService.checkEmbed(this.embedCode);
        this.cardData.embed.body2 = this.sharedService.checkEmbed(this.embedCode2);
        if (this.cardData.embed.body) {
          this.trustedHTML = this.sharedService.makeRenderable(this.sharedService.escToText(this.cardData.embed.body));
          this.sharedService.runEmbedProcessor(this.cardData.embed.body, null);
        }
        if (this.cardData.embed.body2) {
          this.trustedHTML2 = this.sharedService.makeRenderable(this.sharedService.escToText(this.cardData.embed.body2));
          this.sharedService.runEmbedProcessor(this.cardData.embed.body2, null);
        }
        this.newAdName = '';
        this.newAdEmbed = '';
        this.embedPopup = false;
        this.changeFlag = true;
        this.publishFlag = false;
        this.errorShow = (this.cardData.embed.body || this.cardData.embed.body2) ? false : true;
        this.cardPush(false);
        this.embedCode = '';
        this.embedCode2 = '';
      }
    // } else {
    //   this.snotify.error('Please enter a valid embed', '', this.sharedService.getConfig(false));
    // }
  }

  validateEmbedJSON(json: string){
    return true;
  //   if(json.trim() === ''){
  //      return true;
  //   }
  //   if(json.trim() && (json.includes('<div') && json.includes('</div>'))){
  //      return true;
  //   }
  //   if(json.trim() && (json.includes('<blockquote') && json.includes('</blockquote>'))){
  //     return true;
  //  }
  //   if(json.trim() && (json.includes('<embed') && (json.includes('src=') || json.includes('type=') || json.includes('width=') || json.includes('height=')))){
  //       return true;
  //   }
  //   if(json.trim() && json.includes('<iframe') && json.split('<iframe')[1].split("</iframe>")[0].includes('src=')){
  //     if(json.split('<iframe')[0].trim() != '' || json.split('<iframe')[1].split("</iframe>")[1].trim() != ''){
  //        return false;
  //     }
  //      return true;
  //   }
  //   return false;
  }

  testJSON(text) {
    if(text.trim() == ''){
       return true;
    }
    if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
    replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      try{
        JSON.parse(text);
      }catch(e){
        return false;
      }
      return true;

    } else {
      return false;
    }
  }

  cardPush(flag) {
    if (flag) {
      this.publishFlag = true;
    }
    this.overrideSave();
  }
  filterAutoComplete() {
    this.filteredSectionSuggestion = [];
    this.filteredSubSectionSuggestion = [];
    if (this.storyType === 'collection') {
      this.filteredDesignSuggestion = this.sectionSuggestion;
    }
    if(this.storyType === 'placeholder'){
      this.filteredBannerDesignSuggestion = this.sectionSuggestion;
    }
  }
  filterCollectionTypeAutoComplete() {
    this.filteredSectionSuggestion = [];
    this.filteredSubSectionSuggestion = [];
    if (this.storyType === 'collection') {
      this.filteredCollectionTypeSuggestion = this.collectionTypeSuggestion;
    }
  }
  selectAutoComplete(item, type) {
    if (this.cardData.title === null || this.cardData.title === '') {
      this.publishFlag = false;
      this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
    }
    if(type && type == 'design'){
      this.sectionQuery = item.value;
      this.cardData.metadata.design = item.value;
      this.filteredDesignSuggestion = [];
    }
    if(type && type =='bannerDesign'){
      this.bannerDesignQuery = item.value;
      this.cardData.metadata.banner.design = item.value;
      this.filteredBannerDesignSuggestion = [];
    }
    if(type && type === 'brunch') {
      this.selectedBrunchEdition = item;
      this.cardData.metadata.brunchEdition = item;
      this.cardData.metadata.brunchEditionId = this.brunchMap.get(item).id;
      this.cardData.metadata.brunchEditionCoverImage = this.brunchMap.get(item).coverImage;
      this.cardData.metadata.brunchEditionCoverImageHeight = this.brunchMap.get(item).coverImageHeight;
      this.cardData.metadata.brunchEditionCoverImageWidth = this.brunchMap.get(item).coverImageWidth;
      this.cardData.metadata.brunchEditionTitle = this.brunchMap.get(item).title;
      this.cardData.metadata.brunchEditionWebUrl = this.brunchMap.get(item).url;
      let date = new Date(this.brunchMap.get(item).editionDate).toISOString();
      // console.log(date.replace('.000Z','+0000'))
      this.cardData.metadata.brunchEditionDate = date.replace('.000Z','+0000');
      this.brunchEditionFilter = [];
    }
    if(type && type == 'seriesPage'){
      this.selectedSeriesPage = item;
      this.cardData.metadata.seriesPageName = item;
      this.cardData.metadata.seriesPageAlias = this.seriesPageMap.get(item).alias;
      this.cardData.metadata.seriesPageShortName = this.seriesPageMap.get(item).shortName;
      this.cardData.metadata.seriesPageDisplayName = this.seriesPageMap.get(item).displayName;
      this.cardData.metadata.seriesPageId = this.seriesPageMap.get(item).seriesId;
      this.cardData.metadata.seriesPageTourId = this.seriesPageMap.get(item).siTourId;
      this.seriesPageFilter = [];
    }
    if(type && type == 'collectionType'){
      this.collectionTypeQuery = item.value;
      this.cardData.metadata.collectionType = item.value;
      this.filteredCollectionTypeSuggestion = [];
    }
    if(type && type == 'positionType'){
      this.positionTypeQuery = item.value;
      this.cardData.metadata.position = item.value;
      this.filteredPositionTypeSuggestion = [];
    }
    if(type && type == 'section'){
      this.sectionInputQuery = item;
      this.cardData.metadata.section = item;
      this.cardData.metadata.name = item;

      if (
        !(this.subSectionSuggestion.hasOwnProperty(item))
        || (this.subSectionSuggestion[item].length < 1)
        || (this.subSectionSuggestion[item].indexOf(this.cardData.metadata.subSection) < 0)) {
        this.cardData.metadata.subSection = '';
        this.cardData.metadata.subSectionId = '';
        this.cardData.metadata.subSectionUrl = '';
        this.subSectionQuery = '';
      }
      this.filteredSectionSuggestion = [];
      this.insideSection = false;
    }
    if(type && type == 'subSection'){
      this.subSectionQuery = item;
      this.cardData.metadata.subSection = item;
      this.cardData.metadata.name = item;
      if (this.cardData.metadata.section === null || this.cardData.metadata.section === '') {
        for (const section in this.subSectionSuggestion) {
          if (section && this.subSectionSuggestion[section].indexOf(item) > -1) {
            this.cardData.metadata.section = section;
            this.sectionInputQuery = section;
            break;
          }
        }
      }
      this.insideSubSection = false;
      this.filteredSubSectionSuggestion = [];
    }

  }
  getDesignList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/element/design/all/collection')
      .subscribe(
        data => {
          this.dataInsertion(data);
        },
        err => {
          console.log(err);
        }
      );
  }

  collectionTypeDataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.collectionTypeSuggestion.push({ 'value': data[i] });
      }
    }
  }

  getListIdToParentfn(obj) {
    if (obj === true) {
      // this.showlockBg = true;
    } else {
      if (obj.length > 1) {
        this.cardData.pinnedArticlesList = [];
        this.cardData.pinnedArticlesList = obj;
        this.changeFlag = true;
        this.saveCard(this.checkfn);
      } else {
        if (obj.article.id != null) {
          if (!this.cardData.pinnedArticlesList) {
            this.cardData.pinnedArticlesList = [];
          }
          let flag = false;
          this.publishFlag = false;
          for (const index in this.cardData.pinnedArticlesList) {
            if (index) {
              const pageList = this.cardData.pinnedArticlesList[index];
              if (pageList.article != null) {
                if (pageList.article.id === obj.article.id) {
                  if (obj.expireAt == null && !obj.positionChange) {
                    this.cardData.pinnedArticlesList.splice(index, 1);
                    this.changeFlag = true;
                  } else {
                    obj = {
                      expireAt: obj.expireAt,
                      position: obj.position,
                      article: {
                        id: obj.article.id
                      }
                    }
                    this.cardData.pinnedArticlesList[index] = obj;
                    this.changeFlag = true;
                  }
                  flag = true;
                  break;
                }
              }
            }
          }
          if (!flag) {
            this.cardData.pinnedArticlesList.push(obj);
            this.changeFlag = true;
          } else {
            if (this.cardData.collectionStories.indexOf(obj.article.id) < 0) {
              this.cardData.collectionStories.splice(0, 0, obj.article.id);
              this.changeFlag = true;
            }
          }
          this.saveCard(this.checkfn);
          // this.showlockBg = false;
        }
      }
    }
  }

  checkfn() {
    // console.log("first")
    let i;
  }

  initializeEditor() {
    setTimeout(() => {
    if(this.editorTable && this.tableHTML){
      this.editorTable.editorInstance.setData(this.tableHTML);
    }
   }, 200);
  }

  getCollectionTypeList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/element/collectiontype/all/collection')
      .subscribe(
        data => {
          this.collectionTypeDataInsertion(data);
        },
        err => {
          console.log(err);
        }
      );
  }

  getPositionTypeList(){
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/element/design/all/embed')
    .subscribe(
      data => {
        this.positionTypeDataInsertion(data);
      },
      err => {
        console.log(err);
      }
    );
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    this.insideCollectionType = false;
    this.insidePositionType = false;
    if (this.subTypeField['_results'][0] && clickedComponent === this.subTypeField['_results'][0].nativeElement) {
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion =[];
      this.filteredCollectionTypeSuggestion = [];
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.insideSubType = true;
      if (this.subtypeQuery === '') {
        this.filteredsubTypeSuggestion = this.subTypeSuggestion;
      }
      this.filteredPositionTypeSuggestion = [];
    }
    else if (this.tagTypeField['_results'][0] && clickedComponent === this.tagTypeField['_results'][0].nativeElement) {
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.filteredCollectionTypeSuggestion = [];
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.insideTagType = true;
      if (this.tagtypeQuery === '') {
        this.filteredtagTypeSuggestion = this.tagTypeSuggestion;
      }
      this.filteredPositionTypeSuggestion = [];
    }
    else if (this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.filteredDesignSuggestion = [];
      this.filteredCollectionTypeSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.insideDesign = false;
      this.filteredDesignSuggestion = this.sectionSuggestion;
      this.filteredBannerDesignSuggestion = this.sectionSuggestion;
      this.insideSection = false;
      this.insideSubSection = false;
      this.filteredPositionTypeSuggestion = [];
    } else if (this.collectionTypeField['_results'][0] && clickedComponent === this.collectionTypeField['_results'][0].nativeElement) {
      this.insideDesign = false;
      this.insideCollectionType = true;
      this.insideBrunch = false;
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.insidePositionType = false;
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.filteredPositionTypeSuggestion = [];
      this.filteredCollectionTypeSuggestion = this.collectionTypeSuggestion;
      this.insideSection = false;
      this.insideSubSection = false;
    }
    else if (this.positionTypeField['_results'][0] && clickedComponent === this.positionTypeField['_results'][0].nativeElement) {
      this.insideDesign = false;
      this.insideCollectionType = false;
      this.insideBrunch = false;
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.insidePositionType = true;
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.filteredCollectionTypeSuggestion = [];
      this.filteredPositionTypeSuggestion = this.positionTypeSuggestion;
      this.insideSection = false;
      this.insideSubSection = false;
    } else if (this.brunchField['_results'][0] && clickedComponent === this.brunchField['_results'][0].nativeElement) {
      this.insideBrunch = true;
      if (this.selectedBrunchEdition === '') {
        this.brunchEditionFilter = this.brunchEditionData;
      }
    }else if (this.seriesPageField['_results'][0] && clickedComponent === this.seriesPageField['_results'][0].nativeElement) {
      this.insideSeriesPage = true;
      if (this.selectedSeriesPage === '') {
        this.seriesPageFilter = this.seriesPageData;
      }
    }else if (this.section['_results'][0] && clickedComponent === this.section['_results'][0].nativeElement) {
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.filteredCollectionTypeSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.insideSection = true;
      if (this.sectionInputQuery === '' || this.sectionInputQuery === null) {
        this.filteredSectionSuggestion = this.sectionInputSuggestion;
      }
      this.insideSubSection = false;
      this.filteredSubSectionSuggestion = [];
      this.filteredPositionTypeSuggestion = [];
    }else if (this.subSectionField['_results'][0] && clickedComponent === this.subSectionField['_results'][0].nativeElement) {
      this.insideSubSection = true;
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.filteredCollectionTypeSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredPositionTypeSuggestion = [];
      if (this.subSectionQuery === '') {
        if (this.cardData.metadata.section !== null && this.cardData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.cardData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = this.allSubSections;
        }
      }
      this.insideSection = false;
      this.filteredSectionSuggestion = [];
    } else {
      this.insideSection = false;
      this.insideSubSection = false;
      this.insideSubType =false;
      this.insideBrunch = false;
      this.insideSeriesPage = false;
      this.insideTagType =false;
      this.insideDesign = false;
      this.filteredDesignSuggestion = [];
      this.filteredBannerDesignSuggestion = [];
      this.filteredCollectionTypeSuggestion = [];
      this.filteredsubTypeSuggestion = [];
      this.filteredtagTypeSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredPositionTypeSuggestion = [];
    }
    if (this.secondaryCTA && !this.secondaryCTA.nativeElement.contains(clickedComponent)) {
      this.revertListFlag = false;
    }
    if (clickedComponent === 83 && event.ctrlKey
      || event.metaKey && clickedComponent === 83) {
      // alert('save');
    }
  }
  dataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.sectionSuggestion.push({ 'value': data[i] });
      }
    }
  }

  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }

  getArticleIdToParentfn(obj) {
    if (this.cardData && this.cardData.title) {
      if ((this.cardData.metadata.topic.length < 1 && (this.cardData.metadata.section == null &&
        this.cardData.metadata.subSection == null) || (this.cardData.metadata.section === '' &&
          this.cardData.metadata.subSection === '')) && this.cardData.collectionPages == null){
        if (!this.cardData.collectionStories) {
          this.cardData.collectionStories = [];
        }
        let flag = false;
        this.publishFlag = false;
        for (const index in this.cardData.collectionStories) {
          if (index) {
            const i = index;
            const pageList = this.cardData.collectionStories[i];
            if (pageList === obj) {
              this.cardData.collectionStories[i] = obj;
              flag = true;
              break;
            }
          }
        }
        if (!flag) {
          if (obj.length > 1) {
            this.cardData.collectionStories = [];
            this.cardData.collectionStories = obj;
          } else {
            this.cardData.collectionStories = [];
            this.cardData.collectionStories = obj;
          }
          this.changeFlag = true;
        }
        this.cardPush(false);
      }
    else if(this.cardData.collectionPages !== null ){
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Discard Collection of Pages?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.cardData.collectionPages = null;
              this.collectionPages=null;
              this.snotify.remove(toast.id);
              this.cardData.collectionStories = [];
              this.cardData.collectionStories = obj;
              this.changeFlag = true;
              this.cardPush(false);
              this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
            this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
          } }
        ]
      });
    }
    else {
      if (this.isSectionAndSubSectionEnabled()) {
        this.cardData.collectionStories = [];
                this.cardData.collectionStories = obj;
                this.changeFlag = true;
                this.cardPush(false);
      } else {
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('Discard page?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                this.setNullValue();
                this.snotify.remove(toast.id);
                this.cardData.collectionStories = [];
                this.cardData.collectionStories = obj;
                this.changeFlag = true;
                this.cardPush(false);
                this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
              }, bold: false
            },
            { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            } }
          ]
        });
      }
      }
    } else {
      this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
    }
  }

  deleteFromListOfPage(obj)
  {
    this.cardData.collectionPages = obj;
  }

  getPageMultipleParentFn(obj){
    if(this.cardData.title){
      if ((this.cardData.metadata.topic.length < 1 && (this.cardData.metadata.section == null &&
        this.cardData.metadata.subSection == null) || (this.cardData.metadata.section === '' &&
        this.cardData.metadata.subSection === '')) && this.cardData.collectionStories.length === 0){
          const pid = (obj.data && obj.data.children && obj.data.children[0]) ? obj.data.children[0].id : null;
          if(this.collectionPages && this.collectionPages.indexOf(Number(pid))=== -1){
            this.collectionPages.push(Number(pid))
          } else if(!this.collectionPages){
            this.collectionPages = [pid];
          }
          this.cardData.collectionPages = this.collectionPages;
      }
      else if (this.cardData.collectionStories.length > 0) {
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('Discard story?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                this.cardData.collectionStories = [];
                this.snotify.remove(toast.id);
                this.changeFlag = true;
                this.cardPush(false);
                this.googleAnalytics("Skippable Alerts","Discard story?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
              }, bold: false
            },
            { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Discard story?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            } }
          ]
        });
      }
      else{
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('Discard page?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
               this.setNullValue();
               this.snotify.remove(toast.id);
               this.changeFlag = true;
               this.cardPush(false);
               this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
              }, bold: false
            },
            { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            } }
          ]
        });
      }
    }
    else{
      this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
    }

  }

  getPageDataParentfn(obj) {
    if ((this.cardData.collectionStories.length < 1) && (!this.cardData.collectionPages) ){
      const id = (obj.data && obj.data.children && obj.data.children[0]) ? obj.data.children[0].id : null;
      if (obj.type !== 'SECTION' || obj.type !== 'SUBSECTION' || obj.type !== 'APP_SECTION' || obj.type !== 'APP_SUBSECTION') {
        this.cardData.metadata.sectionId = null;
        this.cardData.metadata.sectionUrl = null;
        this.cardData.metadata.name = null;
        this.cardData.metadata.section = null;
        this.cardData.metadata.subSectionUrl = null;
        this.cardData.metadata.subSection = null;
        this.cardData.metadata.subSectionId = null;
      }
      if (obj.type !== 'TOPIC') {
        this.cardData.metadata.topic = [];
        this.cardData.metadata.topicIds = [];
      }
      if (obj.type !== 'AGENCY') {
        this.cardData.metadata.agency = null;
        this.cardData.metadata.agencyId = null;
      }
      if(obj.type !== 'COMPANY') {
        this.cardData.metadata.companyPageName =null;
        this.cardData.metadata.companyPageId = null;
        // this.cardData.metadata.name = obj.name;
      }
      if (obj.type === 'TOPIC') {
        this.cardData.metadata.topic = [obj.title];
        this.cardData.metadata.name = obj.name;
        this.cardData.metadata.topicIds = [id];
      } else if (obj.type === 'SECTION') {
        this.cardData.metadata.name = obj.name;
        this.cardData.metadata.section = obj.title;
        this.cardData.metadata.sectionId = id;
      } else if (obj.type === 'SUBSECTION') {
        this.cardData.metadata.section = obj.section;
        this.cardData.metadata.name = obj.name;
        this.cardData.metadata.subSectionId = id;
        this.cardData.metadata.subSection = obj.title;
      } else if (obj.type === 'AGENCY') {
        this.cardData.metadata.agency = obj.title;
        this.cardData.metadata.agencyId = id;
        this.cardData.metadata.name = obj.name;
      } else if(obj.type === 'COMPANY') {
        this.cardData.metadata.companyPageName = obj.name;
        this.cardData.metadata.companyPageId = id;
        // this.cardData.metadata.name = obj.name;
      }else if (obj.type === 'APP_SECTION') {
        this.cardData.metadata.name = obj.name;
        this.cardData.metadata.section = obj.title;
        this.cardData.metadata.sectionId = id;
      } else if (obj.type === 'APP_SUBSECTION') {
        this.cardData.metadata.section = obj.section;
        this.cardData.metadata.name = obj.name;
        this.cardData.metadata.subSectionId = id;
        this.cardData.metadata.subSection = obj.title;
      }else {
        this.cardData.metadata.name = null;
        this.pageName = null;
        this.sectionName = null;
      }
      setTimeout(e3 => {
        this.changeFlag = true;
        this.isLocked = true;
        this.saveCard(data => { });
      }, 100);
    }
    else if(this.cardData.collectionPages){
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Discard Collection of Pages?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.cardData.collectionPages = null;
              this.snotify.remove(toast.id);
              this.cardData.collectionStories = [];
              this.collectionPages=[];
              this.changeFlag = true;
              this.cardPush(false);
              this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
            this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
          } }
        ]
      });
    } else {
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Discard story?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.cardData.collectionStories = [];
              this.snotify.remove(toast.id);
              this.changeFlag = true;
              this.googleAnalytics("Skippable Alerts","Discard story?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
            this.googleAnalytics("Skippable Alerts","Discard story?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
          } }
        ]
      });

    }
  }

  checkErrorStatus(type){
    if(type === 'url') {
      const val = ((this.s_url.value && this.s_url.invalid) || (!this.externalUrl && this.errorShow));
      return val;
    }
  }

  checkExternalURL(url){
     if(this.s_url.valid && this.externalUrl){
      this.changeFlag = true;

     }
  }


  saveCard(callback) {

    if (this.isLocked) {
      if (this.publishFlag === true) {
        this.changeFlag = true;
      }
      if (this.changeFlag === true) {

        if (this.form.status === 'VALID' || this.externalUrl === '' || this.externalUrl === null) {
          const cardData = this.cardData;
          if (cardData && this.cardData.title) {
            if ((this.storyType === 'embed')
              && (!this.cardData.embed.label.text && this.publishFlag === true && this.showLabel == true)) {
              this.snotify.warning('Please enter label text',
                '', this.sharedService.getConfig(false));
                return;
            }
            if (this.cardData.metadata.count) {
              this.cardData.metadata.count = Number(this.cardData.metadata.count);
            }
            if (this.storyType === 'embed' &&
              (!this.cardData.embed.body && !this.cardData.embed.body2 && !this.externalUrl && this.publishFlag === true) && !this.cardData.amazonMeta) {
                this.snotify.error('Please enter either embed code or External Source Url', '', this.sharedService.getConfig(false));
                this.publishFlag = false;
                return;
            }

            if ((this.storyType === 'jsonfeed' &&
              this.publishFlag === true) && (this.cardData.embed.body === '' && this.cardData.jsonSourceUrl === '')) {
                this.snotify.error('Please enter either embed code or JSON Source Url', '', this.sharedService.getConfig(false));
                this.publishFlag = false;
                return;
            }
            if ((this.domainConfig.config.jsonfeed.subtype !== 'false') && (this.storyType === 'jsonfeed' && this.publishFlag === true) && (!this.cardData.subType || this.cardData.subType === '')) {
                this.snotify.error('Please Enter SubType', '', this.sharedService.getConfig(false));
                this.publishFlag = false;
                return;
            }
            this.namePresent = true;
            if (cardData.id !== null && String(cardData.id) !== '') {
              if (this.publishFlag || this.cardData.metadata.status === 'PUBLISHED') {
                this.cardData.metadata.status = 'PUBLISHED';
              }
              this.cardData.reusable = true;
              this.cardData.metadata.externalUrl = this.externalUrl;
              if(this.saveRequestSent === false) {
                this.saveRequestSent = true;
                this.restService.http_put(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
                + '/' + String(cardData.id) + (this.publishFlag ? '' : '?autoSave=true'),
                this.cardData,
                result => {
                  this.saveRequestSent = false;
                  if (!result || result.hasOwnProperty('error')) {
                    this.changeFlag = false;
                    this.publishFlag = false;
                    if (result.status === 423) {
                      this.snotify.warning('someone locked this story forcefully',
                        'Forcefully locked', this.sharedService.getConfig(false));
                    } else if (result.status === 403) {
                      this.snotify.error('You don’t have permission to publish', '', this.sharedService.getConfig(false));
                    } else if (result.status === 409) {
                      this.snotify.error(result.error.errorMessage, '', this.sharedService.getConfig(false));
                    }
                    else {
                      this.snotify.error('There was some error', 'Something bad happened', this.sharedService.getConfig(false));
                    }
                  } else {
                  this.sharedService.setTitle(result.title);
                  this.collectionStories = [];
                  this.pushPinnedArticles = [];
                  this.pushPinnedArticles = result.pinnedArticlesList;
                  if (this.storyType === 'toptrends') {
                    this.objKeys = result.trending;
                  }

                  this.collectionStories = result.collectionStories;
                  if (this.storyType === 'embed') {
                    if (result.embed.backgroundColor === '#ffffff') {
                      this.backColor = 'White';
                      this.color = 'Black';
                    } else {
                      this.backColor = 'Black';
                      this.color = 'White';
                    }
                    this.cardData.embed.fontColor = result.embed.fontColor;
                  }
                  this.cardTitle = result.title;
                  this.mergeData = result.collectionStories;

                  this.sectionQuery = result.metadata ? result.metadata.design : '';
                  this.bannerDesignQuery = (result.metadata.banner && result.metadata.banner.design) ? result.metadata.banner.design : '';
                  this.collectionTypeQuery = result.metadata ? result.metadata.collectionType : '';
                  this.selectedBrunchEdition = result.metadata ? result.metadata.brunchEdition : '';
                  this.selectedSeriesPage = result.metadata ? result.metadata.seriesPageName : '';
                  this.sectionInputQuery = result.metadata ? result.metadata.section : '';
                  this.subSectionQuery = result.metadata ? result.metadata.subSection : '';
                  this.positionTypeQuery = (result.metadata && result.metadata.position) ? result.metadata.position :'';

                  if (this.cardData !== null) {
                    this.cardData['lastModifiedDate'] = result['lastModifiedDate'];
                    this.cardData['lastPublishedDate'] = result['lastPublishedDate'];
                    this.cardData['lastModifiedBy'] = result['lastModifiedBy'];
                    this.cardData['lastPublishedBy'] = result['lastPublishedBy'];
                    this.cardData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                    this.cardData['lastModifiedBy'] = result['lastModifiedBy'];
                    this.cardData['firstPublishedDate'] = result['firstPublishedDate'];
                    this.cardData['metadata']['sectionId'] = result['metadata']['sectionId'];
                    this.cardData['metadata']['subSectionId'] = result['metadata']['subSectionId'];
                    this.cardData['metadata']['subSectionL2Id'] = result['metadata']['subSectionL2Id'];
                    this.cardData['metadata']['topicIds'] = result['metadata']['topicIds'];
                    this.cardData['collectionStories'] = result['collectionStories'];
                    this.cardData['createdBy'] = result['createdBy'];
                    this.collectionStories = [];
                    this.cardData['collectionStoriesVersion'] = result['collectionStoriesVersion'];
                    this.collectionStories = this.cardData.collectionStories;
                    if(this.storyCollection) {
                      this.storyCollection.getArticleDataFromCollection(this.collectionStories);
                      // this.countChange = false;
                    }

                  }

                  if (result.metadata && result.metadata.topic && result.metadata.topic.length > 0) {
                    this.pageName = result.metadata.name;
                  } else if (result.metadata.subSection !== null) {
                    this.sectionName = result.metadata.section;
                    this.pageName = result.metadata.name;
                  } else if (result.metadata.section !== null) {
                    this.pageName = result.metadata.name;
                  } else if(result.metadata.companyPageName !== null){
                    this.pageName = result.metadata.companyPageName;
                  }else {
                    this.pageName = null;
                  }
                  if (this.publishFlag && this.cardData.isDeleted !== 1) {
                    if(result.metadata.count === 10) {
                      this.cardData['metadata']['count']  = result['metadata']['count'];
                    } else {
                      this.count = "";
                    }
                    this.publishFlag = false;
                    this.snotify.success('Updated and published successfully', '', this.sharedService.getConfig(false));
                  }
                }
                  setTimeout(e4 => {
                    this.changeFlag = false;
                    this.sharedService.sendData('saved|false');
                  }, 10);
                  callback(result);
                });
              }
              } else if (!this.requestInQueue) {
              this.cardData.id = null;
              if (this.storyType === 'embed') {
                this.cardData.embed.backgroundColor = '#ffffff';
                this.cardData.embed.fontColor = '#212121';
                this.cardData.metadata.position = this.positionTypeQuery;
              }
              this.cardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
              this.cardData.metadata.design = this.sectionQuery;
              if(this.cardData.type === 'placeholder'){
              this.cardData.metadata.banner.design = this.bannerDesignQuery;
            }
              this.cardData.metadata.collectionType = this.collectionTypeQuery;
              this.cardData.metadata.section = this.sectionInputQuery;
              this.cardData.metadata.subSection = this.subSectionQuery;
              this.cardData.metadata.externalUrl = this.externalUrl;
              this.cardData.reusable = true;
              this.requestInQueue = true;
              this.restService.http_post(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api),
                this.cardData, result => {
              this.requestInQueue = false;
                  if (this.storyType === 'embed') {
                    if (result.embed.backgroundColor === '#ffffff') {
                      this.backColor = 'White';
                      this.color = 'Black';
                    } else {
                      this.backColor = 'Black';
                      this.color = 'White';
                    }
                    this.showLabel = result.embed.labelEnabled;
                    this.cardData.embed.fontColor = result.embed.fontColor;
                  }
                  this.cardTitle = result.title;
                  this.sharedService.setTitle(result.title);
                  this.cardData.id = result.id;
                  this.cardData.lockedByUserId = result.lockedByUserId;
                  this.cardData.lockedByUserName = result.lockedByUserName;
                  this.location.replaceState('/dash/element/' + result.id);
                  if (this.cardData !== null) {
                    this.cardData['lastModifiedDate'] = result['lastModifiedDate'];
                    this.cardData['lastPublishedDate'] = result['lastPublishedDate'];
                    this.cardData['lastModifiedBy'] = result['lastModifiedBy'];
                    this.cardData['lastPublishedBy'] = result['lastPublishedBy'];
                    this.cardData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                    this.cardData['lastModifiedBy'] = result['lastModifiedBy'];
                    this.cardData['firstPublishedDate'] = result['firstPublishedDate'];
                    this.cardData['metadata']['sectionId'] = result['metadata']['sectionId'];
                    this.cardData['metadata']['subSectionId'] = result['metadata']['subSectionId'];
                    this.cardData['metadata']['subSectionL2Id'] = result['metadata']['subSectionL2Id'];
                    this.cardData['metadata']['topicIds'] = result['metadata']['topicIds'];
                    this.cardData['collectionStoriesVersion'] = result['collectionStoriesVersion'];
                    this.cardData['createdBy'] = result['createdBy'];
                    if(result.metadata.count > 0) {
                      this.cardData['metadata']['count']  = result['metadata']['count'];
                    } else {
                      this.count = "";
                    }
                  }
                  this.sharedService.sendData('saved|false');
                  setTimeout(e4 => {
                    this.changeFlag = false;
                    this.sharedService.sendData('saved|false');
                  }, 10);
                  callback(result);
                });
            }
          } else {
            this.namePresent = false;
            this.changeFlag = false;
            this.publishFlag = false;
            this.sharedService.sendData('saved|false');
            this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
            if (this.storyType === 'jsonfeed' && (this.cardData.embed.body === '' && this.cardData.jsonSourceUrl === '')) {
              this.snotify.error('Please enter either embed code or JSON Source Url', '', this.sharedService.getConfig(false));
              this.publishFlag = false;
            }
            callback(null);
          }
        } else {
          this.snotify.error('Please enter valid external url', '', this.sharedService.getConfig(false));
          this.changeFlag = false;
          this.publishFlag = false;
          this.sharedService.sendData('saved|false');
          callback(null);
          // this.snotify.clear();
        }
      } else {
        callback(null);
      }
    } else {
      callback(null);
    }

  }
  getStoryDynamicMetaIndex(field) {
    let dynamicMeta = { 'key': field, 'value': '' };
    if (this.cardData.metadata.dynamicMeta) {
      const exist = this.cardData.metadata.dynamicMeta.filter(meta => meta.key === field);
      if (exist && exist.length > 0) {
        return exist[0];
      } else {
        return dynamicMeta;
      }
    }
    return dynamicMeta;
  }
  saveDynamicMetaValue(receivedToggleValue, field) {
    if (this.cardData.metadata.dynamicMeta) {
      const index = this.cardData.metadata.dynamicMeta.filter(meta =>
        meta.key === field
      );
      if (index && index.length > 0) {
        this.cardData.metadata.dynamicMeta.forEach((meta, i) => {
          if (meta.key === field) {
            this.cardData.metadata.dynamicMeta[i].value = receivedToggleValue.value;
          }
        })
      } else {
        this.cardData.metadata.dynamicMeta.push(receivedToggleValue);
      }
    } else {
      this.cardData.metadata.dynamicMeta = [];
      this.cardData.metadata.dynamicMeta.push(receivedToggleValue);
    }
  }
  loadView(id, option) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
      + '/'
      + String(id)
    ).subscribe(
      data => {
        this.sharedService.sendData('saved|false');
        this.cardData = data;
        this.cardData.lockedByUserId = data.lockedByUserId;
        this.cardData.lockedByUserName = data.lockedByUserName;
        this.sectionQuery = data.metadata.design;
        this.bannerDesignQuery = (data.metadata.banner && data.metadata.banner.design)? data.metadata.banner.design:this.bannerDesignQuery;
        this.pushPinnedArticles = [];
        this.pushPinnedArticles = data.pinnedArticlesList;
        this.collectionTypeQuery = data.metadata.collectionType;
        this.positionTypeQuery = (data.metadata.position) ? data.metadata.position :'';
        this.selectedBrunchEdition = data.metadata.brunchEdition;
        this.selectedSeriesPage = data.metadata.seriesPageName;
        this.sectionInputQuery = data.metadata.section;
        this.subSectionQuery = data.metadata.subSection;
        this.storyType = data.type;
        if(data.metadata.count > 0) {
          this.cardData['metadata']['count']  = data['metadata']['count'];
        } else {
          this.cardData['metadata']['count']  = "";
        }
        if(this.cardData.subType){
        this.subtypeQuery = this.cardData.subType;
        }
        if(this.cardData.tagTypeApp){
        this.tagtypeQuery = this.cardData.tagTypeApp;
        }

        if (this.storyType === 'chart') {
          this.tableHTML = data.chart.chartBody;
          this.chartConfig = JSON.parse(data.chart.configString);
          this.chartType = this.chartConfig.type;
          this.chartLabels.chartlabel = this.chartConfig.options.title.text;
          this.chartLabels.xlabel = this.chartConfig.options.scales.xAxes[0].scaleLabel.labelString;
          this.chartLabels.ylabel = this.chartConfig.options.scales.yAxes[0].scaleLabel.labelString;
          this.renderChart(this.chartConfig, false);
        }

        if (this.storyType === 'embed') {
          if (this.cardData.embed.body) {
            this.trustedHTML = this.sharedService.makeRenderable(this.sharedService.escToText(this.cardData.embed.body));
            this.sharedService.runEmbedProcessor(this.cardData.embed.body, null);
          }
          if (this.cardData.embed.body2) {
            this.trustedHTML2 = this.sharedService.makeRenderable(this.sharedService.escToText(this.cardData.embed.body2));
            this.sharedService.runEmbedProcessor(this.cardData.embed.body2, null);
          }
          if(data.amazonMeta) {
            this.amazonAds = data.amazonAds;
            this.showAmazonMeta = data.amazonMeta;
          }

          if (data.embed.backgroundColor === '#ffffff') {
            this.backColor = 'White';
            this.color = 'Black';
          } else {
            this.backColor = 'Black';
            this.color = 'White';
          }
          if (data.embed.label !== null) {
            this.cardData.embed.label.text = data.embed.label.text;
          } else {
            this.cardData.embed.label = {
              'text': '',
              'backgroundColor': '',
              'fontColor': ''
            };
          }
          this.showLabel = data.embed.labelEnabled;
          this.cardData.embed.fontColor = data.embed.fontColor;
          this.cardData.embed.title = data.embed.title;
          this.sharedService.setTitle(data.embed.title);
        }
        if (this.storyType === 'toptrends') {
          this.objKeys = data.trending;
        }
        this.externalUrl = this.cardData.metadata.externalUrl;
        if (this.storyType === 'embed') {
        if (!this.externalUrl && !this.cardData.embed && !this.cardData.embed.body && !this.cardData.embed.body2) {
           this.errorShow = true;
           this.publishFlag = false;
        }
      }
        this.sharedService.setTitle(data.title);
        this.cardLoaded = true;
        this.cardData.title = data.title;
        this.cardTitle = data.title;
        if (data.metadata.topic && data.metadata.topic.length > 0) {
          this.pageName = data.metadata.name;
          this.Category = 'page';
        } else if (data.metadata.subSection !== null && data.metadata.subSection.length > 0) {
          this.sectionName = data.metadata.section;
          this.pageName = data.metadata.name;
          this.Category = 'page';
        } else if (data.metadata.section !== null  && data.metadata.section.length > 0) {
          this.pageName = data.metadata.name;
          this.Category = 'page';
        } else if(data.metadata.companyPageName !== null) {
          this.pageName = data.metadata.name;
          this.Category = 'page';
        }
        else if (data.collectionPages !== null && data.collectionPages.length > 0) {
          this.pageName = null;
          this.Category = 'page';
          this.multiplePageListingFlag=true;
        }
         else {
          this.pageName = null;
          this.Category = 'story';
        }
        if (data.collectionStories === null) {
          this.cardData.collectionStories = [];
        } else {
          this.collectionStories = data.collectionStories;
          this.mergeData = data.collectionStories;
        }
        if (data.collectionPages === null) {
          this.cardData.collectionPages = null;
        } else {
          this.collectionPages = data.collectionPages;
          this.mergeData = data.collectionPages;
        }
        const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
        const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
        if (option && role && (role === 'ROLE_ADMIN' || role === 'ROLE_SUPER_ADMIN' || role === 'ROLE_EDITOR' || role==='ROLE_SITE_MANAGER')  && !(this.accessType=='View')) {
          const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock'); // Omit props what i don't need
          this.snotify.confirm('Locked by ' + data.lockedByUserName + ', Unlock?', '', {
            ...config,
            buttons: [
              {
                text: 'Yes', action: (toast) => {
                  this.snotify.remove(toast.id);
                  this.unlockStory(id, flag => {
                    if (flag) {
                      this.lockAcquire(id, flag2 => {
                        if (flag2) {
                          this.loadView(id, false);
                          this.getnewData = true;
                          this.editCardFlag = true;
                        } else {
                          this.editCardFlag = false;
                        }
                      });
                    } else {
                      this.changeFlag = false;
                      this.editCardFlag = false;
                    }
                  });
                  this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
                }, bold: false
              },
              {
                text: 'No', action: (toast) => {
                  this.snotify.remove(toast.id);
                  this.editCardFlag = false;
                  this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
                }
              }
            ]
          });
        }
        this.loadJqueryViewMethods();
        // this.editCardFlag = true;
      },
      error => {
        this.editCardFlag = false;
        if (error.status !== 401) {
          setTimeout(e => {
          this.snotify.error('Element Id doesn\'t exist', '', this.sharedService.getConfig(false));
          }, 10);
          this.ngZone.run(() => {
            this.router.navigate(['/dash/elements']);
          });
        } else {
          this.ngZone.run(() => {
            this.router.navigate(['/login']);
          });
        }
      });
  }
  generateCardAutoSaveInterval() {

    if (!this.autosave) {
      this.autosave = setInterval(() => {
        if (this.cardData && this.cardData.title && this.cardData.title.trim() !== '') {
          this.saveCard(data => { });
        }
      }, 1500);
    }
  }

  destroyCardAutoSaveInterval() {
    if (this.autosave) {
      clearInterval(this.autosave);
      this.autosave = null;
    }
  }
  canDeactivate() {
    if (this.cardData && this.cardLoaded && this.cardData.isDeleted !== 1) {
      if (this.changeFlag && !(this.accessType=='View')) {
        const x = window.confirm('Discard changes?');
        if (!x) {
          this.loadJqueryViewMethods();
          return false;
        } else {
          if (this.cardData.id === null) {
            return true;
          } else {
            this.lockRelease(this.cardData.id, data => {
             // console.log(data ? 'lock released of id=> ' + this.cardData.id : 'lock not released');
              return data;
            });
            return true;
          }
        }
      } else {
        if (this.cardData && this.cardData.id === null) {
          return true;
        } else {
          if (this.cardData) {
            this.lockRelease(this.cardData.id, data => {
            //  console.log(data ? 'lock released of id=> ' + this.cardData.id : 'lock not released');
              return data;
            });
            return true;
          }
        }
      }
    } else {
      return true;
    }
   // $('#page_saveBtn1').insertAfter('.header_PageBtn');
  //  document.getElementById('page_saveBtn1').insertAdjacentElement('beforeend',document.getElementsByClassName('header_PageBtn')[0]);
  }

  lockRelease(card_id, callback) {
    if (this.isLocked === true) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            this.destroyViewComponents();
            this.isLocked = false;
            callback(data);
          },
          error => {
            console.log(error);
            callback(false);
          });
    } else {
      callback(true);
    }
  }

  lockAcquire(card_id, callback) {
    if (this.isLocked === false && this.accessType!='View') {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            this.isLocked = true;
            callback(data);
          },
          error => {
            console.log(error);
            callback(false);
          });
    } else {
      callback(true);
    }
  }
  releaselocknow(id) {
    // const token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
    // const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    // const auth = `Bearer ` + token.access_token;
    // const url = this.config.get('product').baseUrl
    //   + '/story/lock/release'
    //   + '?Authorization=' + auth
    //   + '&Domain=' + domain
    //   + '&articleId='
    //   + String(id);
    // $.ajax({
    //   url: url,
    //   crossDomain: true,
    //   type: 'GET',
    //   success: () => {
    //     this.isLocked = false;
    //     this.destroyViewComponents();
    //   }
    // });

     this.lockRelease(id, data => {
       return data;
     });

  }

  unlockElemnt() {
    this.unlockStory(this.cardData.id, flag => {
      if (flag) {
        this.lockAcquire(this.cardData.id, flag2 => {
          if (flag2) {
            this.loadView(this.cardData.id, false);
            this.editCardFlag = true;
          } else {
            this.editCardFlag = false;
            this.changeFlag = false;
          }
        });
      } else {
        this.changeFlag = false;
        this.editCardFlag = false;
      }
    });

  }

  unlockStory(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.unlock_element)
      + '?articleId='
      + String(story_id)
    )
      .subscribe(
        data => {
          this.destroyViewComponents();
          callback(data);
        },
        error => {
          callback(false);
        });
  }
  @HostListener('window:unload', ['$event'])
  public onunload(event) {
    this.releaselocknow(this.cardData.id);
  }
  @HostListener('window:keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    if (key === 83 && $event.ctrlKey
      || $event.metaKey && key === 83) {
      $event.preventDefault();
      this.overrideSave();
    } else if (key === 27) {
      this.embedPopup = false;
      this.embedCode = '';
      this.embedCode2 = '';
      this.designPopup = false;
      if (this.cardId == null) {
        this.router.navigate(['/dash/elements']);
      }
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  public confirmUnload($event) {
    this.overrideSave();
    if (this.cardData && this.cardData.id !== null && this.changeFlag) {
      const message = 'Changes are not saved, are you sure you want to leave?';
      if (typeof $event === 'undefined') {
        $event = window.event;
      }
      if ($event) {
        $event.returnValue = message;
      }
      return message;
    } else {
      return true;
    }
  }
  destroyViewComponents() {
    this.destroyCardAutoSaveInterval();
    // tslint:disable-next-line:no-unused-expression
    (this.unlisten) && this.unlisten();
  }
  overrideSave() {
    this.destroyCardAutoSaveInterval();
    this.saveCard(data => {
      this.generateCardAutoSaveInterval();
    });
  }
  ngDoCheck() {
    const localtempvar = this.cardData;
    if (localtempvar) {
      delete localtempvar['createdDate'];
      delete localtempvar['lastModifiedDate'];
    }
    if (this.changeFlag === false) {
      this.sharedService.sendData('saved|false');
    }
    const cochange = this.getDifference(this.lastCardData ? this.lastCardData : '', localtempvar ? JSON.stringify(localtempvar) : '');

    if (this.cardLoaded && cochange !== '') {
      if (localtempvar) {
        this.lastCardData = JSON.stringify(localtempvar);
      }
      if (this.firstLoadCheck > 0) {
        this.changeFlag = true;
        this.sharedService.sendData('saved|true');
      }
      this.firstLoadCheck++;
    }
    if (this.cardData && this.editCardFlag) {
      this.sendPublishDisableCommand(false);
    } else {
      this.sendPublishDisableCommand(true);
    }
  }
  sendPublishDisableCommand(flag) {
    if (flag) {
      this.sharedService.sendData('publish_disable|true');
    } else {
      this.sharedService.sendData('publish_disable|false');
    }
  }

  getDifference(a, b) {
    let i = 0;
    let j = 0;
    let result = '';
    while (j < b.length) {
      if (a[i] !== b[j] || i === a.length) {
        result += b[j];
      } else {
        i++;
      }
      j++;
    }
    return result;
  }
  ngOnDestroy() {
    // if (this.isLocked && this.cardData !== null && this.cardData.id !== null) {
    //   this.releaselocknow(this.cardData.id);
    // }

    this.destroyViewComponents();
    this.destroyCardAutoSaveInterval();
    if (this.subscription.length > 0) {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
    this.snotify.clear();
    // this.cardData = null;
  }
  selectChangeHandler(event: any) {
    if (event.target.value === 'White') {
      this.color = 'Black';
      this.colorValue = '#212121';
      this.cardData.embed.backgroundColor = '#ffffff';
      this.cardData.embed.fontColor = '#212121';
    } else {
      this.color = 'White';
      this.colorValue = '#ffffff';
      this.cardData.embed.fontColor = '#ffffff';
      this.cardData.embed.backgroundColor = '#212121';
    }
  }
  toggleSwitch(type) {
    if(type === 'news') {
      this.showLabel = !this.showLabel;
      if (!this.showLabel) {
        this.cardData.embed.labelEnabled = false;
        this.cardData.embed.label.text = null;
        this.cardData.embed.label.backgroundColor = null;
        this.cardData.embed.label.fontColor = null;
      }
    } else if(type === 'L-band'){
      this.cardData.lshapeBand = !this.cardData.lshapeBand;
    } else if(type === 'APP') {
      this.cardData.metadata.app = !this.cardData.metadata.app;
      if (this.cardData.title === null || this.cardData.title === '') {
        this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
      }
    } else if(type === 'AMP') {
      this.cardData.metadata.amp = !this.cardData.metadata.amp;
      if (this.cardData.title === null || this.cardData.title === '') {
        this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
      }
    } else if(type === 'WEB') {
      this.cardData.metadata.web = !this.cardData.metadata.web;
      if (this.cardData.title === null || this.cardData.title === '') {
        this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
      }
    } else if(type === 'excludeAutomatedContent') {
      this.cardData.metadata.excludeAutomatedContent = !this.cardData.metadata.excludeAutomatedContent;
      if (this.cardData.title === null || this.cardData.title === '') {
        this.snotify.error('Changes will not be saved unless name is entered', '', this.sharedService.getConfig(false));
      }
    }
  }


  toggleEmbedSwitch() {
    this.showAmazonMeta = !this.showAmazonMeta;
    //this.cardData.amazonMeta = this.showAmazonMeta;
  }

  toggleMultiplePage()
  {
    if((this.cardData.metadata.topic.length < 1 && (this.cardData.metadata.section == null &&
      this.cardData.metadata.subSection == null) || (this.cardData.metadata.section === '' &&
      this.cardData.metadata.subSection === '')) && (this.cardData.collectionPages === null)){
        this.multiplePageListingFlag = !this.multiplePageListingFlag;
      }
    else if(this.cardData.collectionPages !== null){
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Discard Collection of Pages?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.cardData.collectionPages = null;
              this.snotify.remove(toast.id);
              this.cardData.collectionStories = [];
              this.collectionPages=[];
              this.changeFlag = true;
              this.cardPush(false);
              this.multiplePageListingFlag = !this.multiplePageListingFlag;
              this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
          const element = <HTMLInputElement> document.getElementById('inputToggle');
          element.checked = true;
          this.googleAnalytics("Skippable Alerts","Discard Collection of Pages?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
        }
        }
        ]
      });
    } else{
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Discard page?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.setNullValue();
              this.snotify.remove(toast.id);
              this.changeFlag = true;
              this.cardPush(false);
              this.multiplePageListingFlag = !this.multiplePageListingFlag;
              this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          { text: 'No', action: (toast) => {
            const element = <HTMLInputElement> document.getElementById('inputToggle');
            element.checked = false;
            this.snotify.remove(toast.id);
            this.googleAnalytics("Skippable Alerts","Discard page?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            } }
        ]
      });
    }
  }

setNullValue() {
  this.cardData.metadata.sectionId = null;
  this.cardData.metadata.sectionUrl = null;
  this.cardData.metadata.name = null;
  this.cardData.metadata.section = null;
  this.cardData.metadata.subSectionUrl = null;
  this.cardData.metadata.subSection = null;
  this.cardData.metadata.subSectionId = null;
  this.cardData.metadata.topic = [];
  this.cardData.metadata.topicIds = [];
  this.cardData.metadata.companyPageId = null;
  this.cardData.metadata.companyPageName = null;
}

  filterAutoCompleteKeyUp(event, model){
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
    if (model === 'section') {
      if (this.insideSection) {
        if (this.sectionInputQuery && this.sectionInputQuery.length > 0) {
          this.filteredSectionSuggestion = this.sectionInputSuggestion.filter(function (el) {
            return el.toLowerCase().indexOf(this.sectionInputQuery.toLowerCase()) > -1;
          }.bind(this));
        } else {
          this.setNullValue();
          this.subSectionQuery = '';
          this.insideSection = false;
          this.filteredSectionSuggestion = this.sectionInputSuggestion;

        }
      } else {
        this.insideSection = true;
        this.filteredSectionSuggestion = [];
      }

    } else if (model === 'subSection') {
      if (this.insideSubSection) {
        if (this.cardData.metadata.section !== null && this.cardData.metadata.section.trim() !== '') {
          if (this.subSectionQuery && this.subSectionQuery.length > 0) {
            this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.cardData.metadata.section].filter(function (el) {
              return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.cardData.metadata.subSection = null;
            this.cardData.metadata.subSectionUrl = null;
            this.cardData.metadata.subSectionId = null;
            this.cardData.metadata.name =  this.cardData.metadata.section;
            this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.cardData.metadata.section];
          }
        } else {
          if (this.subSectionQuery && this.subSectionQuery.length > 0) {
            this.filteredSubSectionSuggestion = this.allSubSections.filter(function (el) {
              return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.cardData.metadata.subSection = '';
            this.filteredSubSectionSuggestion = this.allSubSections;
          }
        }
        this.insideSubSection = true;
      } else {
        this.insideSubSection = true;
        this.filteredSubSectionSuggestion = [];
      }
    }
  }
  return true;
}
  filterAutoCompleteKeyDown(event, model){
    if (event.key === 'Enter') {
      if (model === 'section') {
        this.insideSection = false;
        this.selectAutoComplete(model, this.filteredSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSection') {
        this.insideSubSection = false;
        this.selectAutoComplete(model, this.filteredSubSectionSuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'section') {
        if (this.currentSelection < (this.filteredSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.sectionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'subSection') {
        if (this.currentSelection < (this.filteredSubSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideSection = false;
      this.insideSubSection = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'section') {
          this.sectionList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'subSection') {
          this.subSectionList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      if (this.insideSection || this.insideSubSection) {
        this.focusOutSuggestion(model);
      }
    } else if (event.keyCode === 8) {
      if (this.sectionSuggestion.indexOf(this.cardData.metadata.section) === -1){
        this.sectionSuggestion.push(this.cardData.metadata.section)
      }
    } else {
      this.currentSelection = 0;
    }
    return true;
  }

  filterAutoCompleteUp(event){
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
    if (this.insideSubType) {
      if (this.subtypeQuery && this.subtypeQuery.length > 0) {
        this.filteredsubTypeSuggestion = this.subTypeSuggestion.filter(function (el) {
          return el.toLowerCase().indexOf(this.subtypeQuery.toLowerCase()) > -1;
        }.bind(this));
      } else {
        this.cardData.subType = '';
        this.subtypeQuery = '';
        this.filteredsubTypeSuggestion = this.subTypeSuggestion;
      }
    } else {
      this.insideSubType = true;
      this.filteredsubTypeSuggestion = [];
    }
  }
  }

  fetchBrunchEdition(){
    this.restService.http_get(this.config.get('product').baseUrl
    +'/api/cms/page/brunch-edition/all').subscribe(res=>{
      console.log("response",res);
      let editionNames = [];
      if(res != null && res.length>0)
      {
        this.burnchAllData = res;
        res.forEach(element => {
          if(element.alias != null)
          {
            this.brunchMap.set(element.alias,element);
            editionNames.push(element.alias);
          }
        });
      }
      this.brunchEditionData = editionNames;
      this.brunchEditionFilter = editionNames;
    })
  }

  filterAutoCompleteUpBrunch(event) {
      if (this.selectedBrunchEdition && this.selectedBrunchEdition.length > 0) {
        if (this.insideBrunch) {
          if (this.selectedBrunchEdition.length > 0) {
            this.brunchEditionFilter = this.brunchEditionData.filter(function (el) {
              return el.toLowerCase().indexOf(this.selectedBrunchEdition.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.cardData.metadata.brunchEdition = '';
            this.cardData.metadata.brunchEditionId = null;
            this.selectedBrunchEdition = '';
            this.brunchEditionFilter = this.brunchEditionData;
          }
        } else {
          this.cardData.metadata.brunchEdition = '';
          this.cardData.metadata.brunchEditionId = null;
          this.insideBrunch = true;
          this.brunchEditionFilter = [];
        }
    }
  }

  fetchSeriesPage(){
    this.restService.http_get(this.config.get('product').baseUrl
    +'/api/cms/page/series-page/all').subscribe(res=>{
      console.log("Series Page Data",res);
      let seriesPageNames = [];
      if(res != null && res.length>0)
      {
        this.seriesPageData = res;
        res.forEach(element => {
          if(element.name != null)
          {
            this.seriesPageMap.set(element.name,element);
            seriesPageNames.push(element.name);
          }
        });
      }
      this.seriesPageData = seriesPageNames;
      this.seriesPageFilter = seriesPageNames;
    })
  }

  filterAutoCompleteUpSeriesPage(event) {
    if (this.selectedSeriesPage && this.selectedSeriesPage.length > 0) {
      if (this.insideSeriesPage) {
        if (this.selectedSeriesPage.length > 0) {
          this.seriesPageFilter = this.seriesPageData.filter(function (el) {
            return el.toLowerCase().indexOf(this.selectedSeriesPage.toLowerCase()) > -1;
          }.bind(this));
        } else {
          this.cardData.metadata.seriesPage = '';
          this.selectedSeriesPage = '';
          this.seriesPageFilter = this.seriesPageData;
        }
      } else {
        this.cardData.metadata.seriesPage = '';
        this.insideSeriesPage = true;
        this.seriesPageFilter = [];
      }
  }
}

  filterAutoCompleteUpTagType(event){
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (this.insideTagType) {
        if (this.tagtypeQuery && this.tagtypeQuery.length > 0) {
          this.filteredtagTypeSuggestion = this.tagTypeSuggestion.filter(function (el) {
            return el.toLowerCase().indexOf(this.tagtypeQuery.toLowerCase()) > -1;
          }.bind(this));
        } else {
          this.cardData.tagTypeApp = '';
          this.tagtypeQuery = '';
          this.filteredtagTypeSuggestion = this.tagTypeSuggestion;
        }
      } else {
        this.insideTagType = true;
        this.filteredtagTypeSuggestion = [];
      }
    }
  }

  filterAutoCompleteDown(event) {
    if (event.key === 'Enter') {
      this.insideSubType = false;
      this.selectAutoCompleteSubType(this.filteredsubTypeSuggestion[this.currentSelection]);
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (this.currentSelection < (this.filteredsubTypeSuggestion.length - 1)) {
        this.currentSelection += 1;
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideSubType = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      if (this.insideSubType) {
        this.focusOutSuggest();
      }
    } else {
      this.currentSelection = 0;
    }
    return true;

  }

  filterAutoCompleteDownTagType(event) {
    if (event.key === 'Enter') {
      this.insideTagType = false;
      this.selectAutoCompleteTagType(this.filteredtagTypeSuggestion[this.currentSelection]);
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (this.currentSelection < (this.filteredtagTypeSuggestion.length - 1)) {
        this.currentSelection += 1;
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideTagType = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      if (this.insideTagType) {
        this.focusOutSuggest();
      }
    } else {
      this.currentSelection = 0;
    }
    return true;

  }
  focusOutSuggest() {
    this.insideSubType = false;
    this.insideTagType = false;
    this.insideSection = false;
    this.insideSubSection = false;
    this.filteredSectionSuggestion = [];
    this.filteredSubSectionSuggestion = [];
    this.filteredsubTypeSuggestion = [];
    this.filteredtagTypeSuggestion = [];
    this.currentSelection = 0;
  }

  focusOutSuggestion(model) {
    if(model){
      if(model === 'section'){
        this.insideSection = false;
        this.filteredSectionSuggestion = [];
      }
      if(model === 'subSection'){
        this.insideSubSection = false;
        this.filteredSubSectionSuggestion = [];
      }
      this.currentSelection = 0;
    }
  }

  selectAutoCompleteSubType(item){
    this.subtypeQuery = item;
    this.cardData.subType = item;
    this.filteredsubTypeSuggestion = [];
  }
  selectAutoCompleteTagType(item){
    this.tagtypeQuery = item;
    this.cardData.tagTypeApp = item;
    this.filteredtagTypeSuggestion = [];
  }
  selectAutoCompleteSectionAndSubSection(item,type){
    if(type){
      if(type === 'section'){
        this.sectionInputQuery = item;
        this.cardData.metadata.section = item;
        this.filteredSectionSuggestion = [];
      }
      if(type === 'subSection'){
        this.subSectionQuery = item;
        this.cardData.metadata.subSection = item;
        this.filteredSubSectionSuggestion = [];
      }
    }
  }

  focusInSuggest(){
    this.insideSubType = true;
    if (this.subtypeQuery === '') {
      this.filteredsubTypeSuggestion = this.subTypeSuggestion;
    }

  }
  focusBrunch(){
    this.insideBrunch = true;
      if(this.selectedBrunchEdition === ''){
        this.brunchEditionFilter = this.brunchEditionData;
      }
  }
  focusSeriesPage(){
    this.insideSeriesPage = true;
      if(this.selectedSeriesPage === ''){
        this.seriesPageFilter = this.seriesPageData;
      }
  }
  focusInSuggestTagType(){
    this.insideTagType = true;
    if (this.tagtypeQuery === '') {
      this.filteredtagTypeSuggestion = this.tagTypeSuggestion;
    }

  }

  focusInSuggestion(model){
    if (model === 'section') {
      this.insideSection = true;
      this.filteredDesignSuggestion = [];
      if (this.sectionInputQuery === '' || this.sectionInputQuery === null) {
        this.filteredSectionSuggestion = this.sectionInputSuggestion;
      }
    }
    if (model === 'subSection') {
      this.insideSubSection = true;
      this.filteredDesignSuggestion = [];
      if (this.subSectionQuery === '') {
        if (this.cardData.metadata.section !== null && this.cardData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.cardData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = this.allSubSections;
        }
      }
    }

    this.currentSelection = 0;
    this.filterAutoCompleteKeyUp({ keyCode: 0 }, model);
  }

  deleteCurrentElement() {
    if (this.cardData.id !== null) {
      this.revertListFlag = false;
      this.publishFlag = true;
      this.cardData.isDeleted = 1;
      this.changeFlag = true;
      this.cardLoaded = true;
      this.overrideSave();
      if (this.cardData.title) {
        setTimeout(e => {
          this.router.navigate(['/dash/elements']);
        }, 200);
      }
    }
  }
  labelChanges(obj) {
    if (this.showLabel && obj) {
      this.cardData.embed.labelEnabled = true;
      this.cardData.embed.label.text = null;
      this.cardData.embed.label.backgroundColor = '#f44336';
      this.cardData.embed.label.fontColor = '#ffffff';
    } else {
      this.cardData.embed.labelEnabled = false;
      this.cardData.embed.label.text = null;
      this.cardData.embed.label.backgroundColor = null;
      this.cardData.embed.label.fontColor = null;
    }
  }

  getEmbedPopupTitle() {
    if (this.sharedService.isdomainConfig('story','autoEmbed')) {
      return 'Add Embed code for the video, tweet, etc';
    } else {
      return 'Add Embed code/URL (youtube, dailymotion, & vimeo only) for the video, tweet, etc';
    }
  }
  addTopicTrends(flag, item) {
    if (flag === 'add' && this.trending !== null && this.trending !== '' && this.trending
    && this.trendingUrl !== null && this.trendingUrl !== '' && this.trendingUrl) {
      const result = this.objKeys.find(({ key }) => key === this.trending );
      if (!result) {
        this.objKeys.push({key: this.trending , value: this.trendingUrl});
        this.trending = '';
        this.trendingUrl = '';
        this.cardData.trending = this.objKeys;
      } else {
        this.trending = '';
        this.trendingUrl = '';
      }
    } else if (flag === 'edit') {
      this.objKeys[this.objKeys.indexOf(item)] = item;
      this.cardData.trending = this.objKeys;
      this.trending = '';
      this.trendingUrl = '';
    } else if (flag === 'delete') {
      this.objKeys.splice(this.objKeys.indexOf(item), 1);
      this.cardData.trending = this.objKeys;
      this.trending = '';
      this.trendingUrl = '';
    } else {
      this.snotify.error('Please enter Name and Url', '', this.sharedService.getConfig(false));
    }
  }

  addBanner(flag) {
    if (flag === 'add' && this.bannerName !== null && this.bannerName !== '' && this.bannerUrl
    && this.bannerUrl !== null && this.bannerUrl !== '' && this.bannerUrl) {
      if(!this.cardData.banner){
        this.cardData.banner = [];
      }
      if(this.tempBannerImgUrl) {
        this.cardData.banner.push({
          'key' : this.bannerName,
          'value' : this.bannerUrl,
          'imageId' : '',
          'imageUrl' : this.tempBannerImgUrl
        });

        this.bannerName = '';
        this.bannerUrl = '';
        this.tempBannerImgUrl = '';
      } else {
        this.snotify.error('Please enter Banner Image', '', this.sharedService.getConfig(false));
      }


    } else {
      this.snotify.error('Please enter Name and Url', '', this.sharedService.getConfig(false));
    }
  }

  deleteBanner(i) {
    this.cardData.banner.splice(i, 1);
  }

  getStoryMetaList() {
    // let data=this.localstorageService.getSuggestionData();
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/suggestions')
      .subscribe(
        data => {
          if (data.hasOwnProperty('sections')) {
            this.subSectionSuggestion = data['sections'];
            for (const section in data['sections']) {
              if (section) {
                const sec = section; // .split('name=')[1].split(',')[0];
                this.sectionInputSuggestion.push(sec);
                this.allSubSections = this.allSubSections.concat(data['sections'][sec]);
              }
            }
          }

        },
        err => {
           console.log(err);
        }
      );
  }

  isSectionAndSubSectionEnabled(){
    if(this.domainConfig['config']['collection']){
      if(this.domainConfig['config']['collection']['section'] === "true"){
        this.isSection = true;
        return this.isSection;
      }
      if(this.domainConfig['config']['collection']['subSection'] === "true"){
        this.isSubSection = true;
        return this.isSubSection;
      }
    }
    return false;
  }
  deleteAmazonAd(ev)
  {
    this.amazonAds.splice(ev,1);
  }
  saveAmazonEmbed()
  {
    if(this.newAdName) {
      this.amazonAds.push({key:this.newAdName,value:this.newAdEmbed});
    } else {
      this.snotify.error('Enter Ad Name', '', this.sharedService.getConfig(false));
    }

    this.amazonNewAd = false;
  }
  addAmazonMeta()
  {
    this.newAdName="";
    this.newAdEmbed="";
    this.amazonNewAd = true;
  }
  //for chart & table element
  editTable() {

    if(this.storyType=='chart'){


    this.tableHTML = '<figure class="table">' + this.cardData.chart.chartBody + '</figure>';
    setTimeout(() => {
      this.tablePopup = true;
    }, 100);
  }if(this.storyType=='table'){
    this.tableHTML = '<figure class="table">' + this.cardData.paragraph.body + '</figure>';
    setTimeout(() => {
      this.tablePopup = true;
    }, 100);
  }
  }

//for chart & table element
  saveTable() {
    if(this.storyType=='chart' ){
      this.cardData.chart.chartBody = ('' + this.tableHTML).replace('<figure class="table">', '').replace('</figure>', '');
      this.generateChart();
    }if(this.storyType=='table' ){
      this.cardData.paragraph.body = ('' + this.tableHTML).replace('<figure class="table">', '').replace('</figure>', '');
      this.closeTable();
    }
  }

  generateChart() {
    const mappedConfig = this.getNewMappedConfig();
    const configdata = this.sharedService.generateChartDatasetFromTable(
      this.cardData.chart.chartBody,
      mappedConfig
    );
    mappedConfig['data'] = configdata['data'];
    this.chartConfig = JSON.parse(JSON.stringify(mappedConfig));
    this.cardData.chart.configString = JSON.stringify(mappedConfig);
    this.renderChart(this.chartConfig, true);
    this.closeTable();
  }

  getNewMappedConfig() {
    const newConfig = JSON.parse(JSON.stringify(StaticDataService.chartConfig));
    newConfig['type'] = this.chartType;
    newConfig['options']['title']['text'] = this.chartLabels.chartlabel;
    newConfig['options']['scales']['xAxes'][0]['scaleLabel']['labelString'] = this.chartLabels.xlabel;
    newConfig['options']['scales']['yAxes'][0]['scaleLabel']['labelString']  = this.chartLabels.ylabel;
    return JSON.parse(JSON.stringify(newConfig));
  }

  renderChart(config, ifSaveImage) {
    if (document.getElementById('chartCanvas')) {
      if (ifSaveImage) {
        config['options']['animation'] = {
            onComplete: (animation) => {
              this.saveImageOfChart();
            }
        };
      }
      config['plugins'] = {
        beforeDraw: (chart, easing) => {
          const ctx = chart.chart.ctx;
          ctx.save();
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, chart.width, chart.height);
          ctx.restore();
        }
      };
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new Chart('chartCanvas', config);
    } else {
      setTimeout(e => {
        this.renderChart(config, ifSaveImage);
      }, 300);
    }
  }

  saveImageOfChart() {
    const url_base64jp = this.sharedService.convertBase64ToBlob(this.chart.toBase64Image());
    url_base64jp.then(res => res.blob()).then(e => {
      const fd = new FormData();
      e['lastModifiedDate'] = new Date();
      e['name'] = 'chart';
      fd.append('file', <File>e, 'chart.png');
      this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
        subscribe(res => {
          // console.log(res);
          this.cardData.chart.images = res['images'];
          this.overrideSave();
        });
    });
  }


  closeTable() {
    this.tablePopup = false;
    this.tableHTML = '';
  }

  openDesignPopup() {

    this.designPopup = true;
    this.designImage = '../../../assets/images/' + this.sectionQuery.replace(/\s/g, '') + '.png';
  }
  closeDesignPopup()
  {
    this.designPopup = false;
  }
  changeInType(ev) {
    this.chartType = ev;
    this.generateChart();
  }
  ckchanges(ev, label, model) {
    if (label === 'ready') {
      switch (model) {
        case 'table':
          this.tableEditor = ev;
          break;
        default: break;
      }
    }
    if (label === 'change') {
      if(model === 'table'){
        this.checkingHyperlinkValid(this.tableEditor,model,this.tableHTML);
      }
    }
  }

  checkingHyperlinkValid(editor,type,data) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl = this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
                }
              }, 1000);
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
              }
            }, 1000);
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })

          }
          }
      }
    }
     else {
      return true;
    }
  }

  checkUrlValidate(url,data,type,editor) {
    var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
    let allLink =  this.sharedService.findInvalidLinkWord(editor);
    let matchLinkObj = allLink.filter(e =>e.href===url)
    if(urlValid.test(url) === false) {
       this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     } else if(!url.startsWith('https')) {
       this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     }
     return urlValid.test(url) && url.startsWith('https') ;
  }

  getremoveInvalidLink(cardData,word,type,editor){
    let paraBody=cardData;
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
          // this.saveCard(true, word => {});
        }
      }
  }
  onFileChangeSingle(event, model) {
    this.pickStoryImageLoad = true;
    let file_name = <File>event.target.files[0].name;
    const reader = new FileReader();
    const fd = new FormData();
    this.SingleselectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((typeof event.target.files[0]) === 'object') {
        if ((this.SingleselectedFile.size / 1000000) <= 11) {
          const a = reader.readAsDataURL(event.target.files[0]);
          reader.onload = (e: any) => {
            this.sharedService.checkImageForAMP(reader, flag => {
                this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, model);
            })

      }}
    }
  }
}

uplaodImageAndOpenCropper(imageFile, base64, type) {
  this.sharedService.uploadImage(imageFile).
    subscribe(res => {
     if(type === 'bannerImage') {
      this.cardData.metadata.banner.imageUrl = res['images']['original'];
      this.pickStoryImageLoad = false;
     }
    },
      error => {
        this.snotify.error("Image Upload Failed");
        this.pickStoryImageLoad = false;

      });
  }
  deleteImage(type){
    if(type === 'bannerImage') {
      this.cardData.metadata.banner.imageUrl= null;
    }
  }

  openMatchPopupMeta(){
    this.matchPopupMeta = true;
  }

  openEditMatchPopupMeta(){
    this.editMatchPopupMeta = true;
  }

  deleteMatchDetails(){
    this.cardData.metadata.matchDetail = null;
  }

  getPopupValueToParentfnMeta(obj){
    this.matchPopupMeta = obj;
    this.editMatchPopupMeta = false;
  }

  getMatchDetails(obj){
    let match = {
      matchId: obj.matchId,
      matchNameWithDate: obj.matchNameWithDate,
      seriesId: obj.seriesId,
      seriesName: obj.seriesName
    }
    this.cardData.metadata.matchDetail = match;
  }

  fetchPositionData(){
    this.restService.http_get(this.config.get('product').baseUrl
    +'/api/cms/page/brunch-edition/all').subscribe(res=>{
      console.log("response",res);
      let editionNames = [];
      if(res != null && res.length>0)
      {
        this.burnchAllData = res;
        res.forEach(element => {
          if(element.alias != null)
          {
            this.brunchMap.set(element.alias,element);
            editionNames.push(element.alias);
          }
        });
      }
      this.brunchEditionData = editionNames;
      this.brunchEditionFilter = editionNames;
    })
  }
  filterPositionTypeAutoComplete() {
    this.filteredSectionSuggestion = [];
    this.filteredSubSectionSuggestion = [];
    if (this.storyType === 'embed') {
      this.filteredPositionTypeSuggestion = this.positionTypeSuggestion;
    }
  }
  positionTypeDataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.positionTypeSuggestion.push({ 'value': data[i] });
      }
    }
  }

  updatePositionDate(event) {
    let date = moment.utc(moment(event).utc()).format();
    this.cardData.metadata.date = date.replace('Z', '+0000') 
  }
}
